import { IChatMessagesOut } from '@enuan/chat__utils';
import { createAction, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { set as _set } from 'lodash';
import { resetReducer } from '../../reduxStore/actions/actions';

export interface IFormState {
	message?: IChatMessagesOut;
	touching?: 'texting' | 'recording';
	error?: string;
}
const initialState: IFormState = {};

export const formSlice = createSlice({
	name: 'form',
	initialState,
	reducers: {
		setMessage(state, action: PayloadAction<IFormState['message']>) {
			const { payload: message } = action;
			state.message = message;
		},
		setTouching(
			state,
			action: PayloadAction<IFormState['touching'] | undefined>
		) {
			state.touching = action.payload;
		},
		setError(state, action: PayloadAction<IFormState['error'] | undefined>) {
			state.error = action.payload;
		},
	},
	extraReducers: (builder) =>
		builder
			.addCase(boxAction, (state, action) =>
				_set(state, action.payload.id, action.payload.value)
			)
			.addCase(resetReducer, () => initialState)
			.addDefaultCase((state, action) => {}),
});

const boxAction = createAction<{ id: string; value: any }>('@box/form/update');
